<div class="clinic-dashboard-main main_container" style="background-color: #fff;">
  <clinic-dashboard-header></clinic-dashboard-header>
  <div class="d-flex">
    <clinic-dashboard-provider-list></clinic-dashboard-provider-list>
    <clinic-dashboard-patient-list class="w-100"></clinic-dashboard-patient-list>
  </div>
</div>